import moment from 'moment';

const ISODateToMomentDate = (date: Date) => moment(date, moment.ISO_8601);

export default ISODateToMomentDate;
